export enum CreateMeetingDrawerModalMode {
  // "Чистое" модальное окно с выбором клиента, заявки
  openNewMeeting = 'openNewMeeting',
  // Модальное окно, в котором уже определен клиент и заявка без возможности их изменить
  openWithClientAndLead = 'openWithClientAndLead',
  // Модальное окно, в котором определен клиент без возможности его изменить
  openWithClient = 'openWithClient',
  // Модальное окно создания клиента (перед тем, как создать встречу)
  openCreateClient = 'openCreateClient',
  // Модальное окно создания субагента (перед тем, как создать встречу)
  openCreateSubAgent = 'openCreateSubAgent',
}
